import { checkPrivileges } from "../../Helpers";
import { CATEGORIES, QUESTIONS } from "./questions";

/** Privilege keys matching the same menus/APIs used by each FleetBot area */
export const CATEGORY_PRIVILEGES = {
  vehicles: ["vehicle"],
  // predictions → aiPms, service history → delivery notes
  services: ["aiPms", "deliverynote"],
  invoices: ["invoice"],
  deliveryNotes: ["deliverynote"],
  // savings are computed from delivery notes
  savings: ["deliverynote"],
  // feedbacks POST — keep available when any FleetBot access exists
  customInquiry: null,
};

export const QUESTION_PRIVILEGES = {
  totalVehicles: ["vehicle"],
  servedVehicles: ["vehicle"],
  vehicleDetails: ["vehicle"],
  mileageSummary: ["vehicle"],
  vehiclePicker: ["vehicle"],

  servicesThisMonth: ["aiPms"],
  upcomingServices: ["aiPms"],
  overdueServices: ["aiPms"],
  serviceHistory: ["deliverynote"],

  invoicesCurrentMonth: ["invoice"],
  invoicesLastMonth: ["invoice"],
  pendingInvoices: ["invoice"],
  invoiceSummary: ["invoice"],

  dnCurrentMonth: ["deliverynote"],
  dnLastMonth: ["deliverynote"],
  pendingDeliveryNotes: ["deliverynote"],
  deliveryNoteSummary: ["deliverynote"],

  totalSavings: ["deliverynote"],
  savingsThisMonth: ["deliverynote"],
  marketPriceVsSpent: ["deliverynote"],
  savingsByVehicle: ["deliverynote"],
};

const hasAnyPrivilege = (keys) => {
  if (!keys || !keys.length) return true;
  return keys.some((key) => checkPrivileges(key));
};

export const canAccessCategory = (categoryId) => {
  if (!(categoryId in CATEGORY_PRIVILEGES)) return true;
  return hasAnyPrivilege(CATEGORY_PRIVILEGES[categoryId]);
};

export const canAccessQuestion = (questionId) => {
  if (!(questionId in QUESTION_PRIVILEGES)) return true;
  return hasAnyPrivilege(QUESTION_PRIVILEGES[questionId]);
};

export const getAllowedCategories = () =>
  CATEGORIES.filter((item) => canAccessCategory(item.id));

export const getAllowedQuestions = (categoryId) =>
  (QUESTIONS[categoryId] || []).filter((item) => canAccessQuestion(item.id));

export const hasAnyFleetBotAccess = () => getAllowedCategories().length > 0;

export const assertQuestionPrivilege = (questionId) => {
  if (!canAccessQuestion(questionId)) {
    const error = new Error("Access denied");
    error.status = "error";
    error.message = "Access denied";
    error.statusCode = 403;
    throw error;
  }
};
